angular.module("vgresiduos").controller("FeatureToggleEditCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `master/feature-toggle/${$stateParams.id}`);
		};
	}
]);
